import { AppTester } from 'supporting';

/** Франц. контур хранит локальное имя тега в lang `ru`, в UI показываем FR (как в LangSwitcher). */
export const isTagAdminFrenchLocalLang = (): boolean =>
  AppTester.isFr() || AppTester.isOnlinesDesign();

export const getTagAdminLocalLangFieldKey = (): 'fr' | 'ru' =>
  isTagAdminFrenchLocalLang() ? 'fr' : 'ru';

export const getTagAdminCategoryLocalLangLabelKey = (): string =>
  `main_admin_tag.lang.category.${getTagAdminLocalLangFieldKey()}`;

export const getTagAdminSubcategoryLocalLangLabelKey = (): string =>
  `main_admin_tag.lang.subcategory.${getTagAdminLocalLangFieldKey()}`;

export const getTagsModalLocalNameLabelKey = (): string =>
  isTagAdminFrenchLocalLang() ? 'tags_modal.tag_name_fr' : 'tags_modal.tag_name_rus';
import { AppTester } from 'supporting';

/** Франц. контур хранит локальное имя тега в lang `ru`, в UI показываем FR (как в LangSwitcher). */
export const isTagAdminFrenchLocalLang = (): boolean =>
  AppTester.isFr() || AppTester.isOnlinesDesign();

export const getTagAdminLocalLangFieldKey = (): 'fr' | 'ru' =>
  isTagAdminFrenchLocalLang() ? 'fr' : 'ru';

export const getTagAdminCategoryLocalLangLabelKey = (): string =>
  `main_admin_tag.lang.category.${getTagAdminLocalLangFieldKey()}`;

export const getTagAdminSubcategoryLocalLangLabelKey = (): string =>
  `main_admin_tag.lang.subcategory.${getTagAdminLocalLangFieldKey()}`;

export const getTagsModalLocalNameLabelKey = (): string =>
  isTagAdminFrenchLocalLang() ? 'tags_modal.tag_name_fr' : 'tags_modal.tag_name_rus';
